import { Outlet } from "react-router-dom";
import { Navigation } from "../Navigation/Navigation";
import { Footer } from "../Footer/Footer";
import { LayoutWrapper, MainContent } from "./Layout.styles";

export const Layout = () => {
  return (
    <LayoutWrapper>
      <Navigation />

      <MainContent>
        <Outlet />
      </MainContent>

      <Footer />
    </LayoutWrapper>
  );
};
